import React, { useState, useRef, useEffect } from 'react';
import { Card } from './ui/card';
import { Image, Video, Smartphone, Award, Camera, Calendar } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  Image,
  Video,
  Smartphone,
  Award,
  Camera,
  Calendar
};

const Services = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hoveredId, setHoveredId] = useState(null);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="services" className="bg-[#0B0B0B] py-24" ref={sectionRef}>
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-[#FF3B3B] text-sm font-semibold uppercase tracking-widest mb-4 block">
            Services
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Partnership Options
          </h2>
          <p className="text-[#9CA3AF] text-lg max-w-2xl mx-auto">
            Flexible collaboration packages designed to meet your brand's unique goals and budget.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className={`bg-[#111111] border-white/5 rounded-2xl p-6 transition-all duration-500 hover:-translate-y-2 hover:border-[#FF3B3B]/20 hover:shadow-xl hover:shadow-[#FF3B3B]/5 cursor-pointer group ${
                  isVisible ? 'animate-fadeInUp' : 'opacity-0'
                }`}
                style={{ animationDelay: `${index * 100}ms` }}
                onMouseEnter={() => setHoveredId(service.id)}
                onMouseLeave={() => setHoveredId(null)}
              >
                {/* Icon */}
                <div className={`w-14 h-14 rounded-xl flex items-center justify-center mb-5 transition-all duration-300 ${
                  hoveredId === service.id 
                    ? 'bg-[#FF3B3B] scale-110' 
                    : 'bg-[#FF3B3B]/10'
                }`}>
                  <IconComponent 
                    size={28} 
                    className={`transition-colors duration-300 ${
                      hoveredId === service.id ? 'text-white' : 'text-[#FF3B3B]'
                    }`} 
                  />
                </div>

                {/* Content */}
                <h3 className="text-white text-xl font-bold mb-3 group-hover:text-[#FF3B3B] transition-colors duration-300">
                  {service.title}
                </h3>
                <p className="text-[#9CA3AF] text-sm leading-relaxed mb-4">
                  {service.description}
                </p>

                {/* Price */}
                <div className="pt-4 border-t border-white/5">
                  <span className="text-[#FF3B3B] font-semibold">{service.price}</span>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
